






































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import UserModule from '@/store/modules/user';
import sessionModule, { IUserSession } from '@/store/modules/session';
/** admin banner header */
@Component({})
export default class AdminHeaderComponent extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;
  mounted() {}
  logout() {
    UserModule.LogOut().then(() => {
      location.reload(); // 为了重新实例化vue-router对象 避免bug
    });
  }
}
